import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import {
  ApiClient,
  ApiDocInfo,
  displayTrafficAppStatus,
  getTrafficAppStatusOpt,
} from "../../api/ApiClient";
import { useContext, useEffect, useState } from "react";
import { SiteInfoContext } from "../context/SiteInfoContext";
import { Form, Modal, Typography, Toast } from "@douyinfe/semi-ui";
let apiClient = ApiClient.getDefault();
const { Text } = Typography;
export default function TrafficApp() {
  const [apiDocInfo, setApiDocInfo] = useState(
    undefined as undefined | ApiDocInfo
  );
  const [app, setApp] = useState(undefined as undefined | any);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [selectedTraffics, setSelectedTraffics] = useState([] as any[]);
  useEffect(() => {
    apiClient.getApiDocInfo().then((info) => setApiDocInfo(info.data));
  }, []);
  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      hideInEdit: true,
      type: ColType.STRING,
    },
    {
      name: "名称",
      key: "name",
      type: ColType.STRING,
      showInFilter: false,
    },
    {
      name: "渠道名称",
      key: "names",
      width: 60,
      showInFilter: true,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true, 
      type: ColType.MULTI_SELECT,
      getOptions: () => apiClient.getSourceNameCodeNewAsOpts(),
    },
    {
      name: "Code",
      key: "code",
      type: ColType.STRING,
      showInFilter: false,
      hideInEdit: true,
    },
    {
      name: "渠道编码",
      key: "codes",
      width: 60,
      showInFilter: true,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true, 
      type: ColType.MULTI_SELECT,
      getOptions: () => apiClient.getSourceNameCodeAsOpts(),
    },
    {
      name: "客户总数",
      key: "leadCount",
      type: ColType.STRING,
      showInFilter: true,
      hideInCreate: true,
      hideInEdit: true, 
      render: (v,a) => (a.leadCount == null ? "0" : a.leadCount),
    },
    {
      name: "用户分值",
      key: "score",
      hideInCreate: true,
      hideInEdit: true, 
      hideInList: true,
      type: ColType.NUMBER,
    },
    {
      name: "单客成本",
      key: "cost",
      type: ColType.NUMBER,
    },
    {
      name: "App Key",
      key: "appKey",
      hideInEdit: true,
      hideInCreate: true,
      hideInList: true,
      render: (a) => (
        <Text style={{ fontFamily: "monospace" }} code>
          {a}
        </Text>
      ),
      type: ColType.STRING,
    },
    {
      name: "状态",
      key: "status",
      render: (a) => displayTrafficAppStatus(a),
      type: ColType.SELECT,
      showInFilter: true,
      getOptions: (row) => Promise.resolve(getTrafficAppStatusOpt()),
    },
    {
      name: "创建时间",
      key: "createdAt",
      width: 160,
      type: ColType.DATETIME,
      hideInEdit: true,
      hideInCreate: true,
    },
  ];

  const deleteTrafficApp = (id: number) => {
    Modal.confirm({
      title: "是否确认删除？删除会影响该渠道的客户展示。",
      content: "",
      onOk: async () => {
        try {
          await apiClient.deleteTrafficApp(id);
          Toast.info("删除成功");

          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  const hideLeads = (row: any, rows: any[] | undefined, isHide: number) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择渠道");
      return;
    }
    //校验所选渠道 status（HIDED-已隐藏） 和操作 隐藏、显示isHide的逻辑
    if (isHide == 0 && rows.some((a) => a.status != "HIDED")) {
      Toast.info("请选择已隐藏的渠道");
      return;
    }
    if (isHide == 1 && rows.some((a) => a.status == "HIDED")) {
      Toast.info("请选择未隐藏的渠道");
      return;
    }
    Modal.confirm({
      title:
        isHide == 1
          ? "是否确认隐藏这些渠道的客户？隐藏的客户所有页面都将不再展示。"
          : "是否确认取消隐藏这些渠道的客户？取消隐藏的客户所有页面都将展示。",
      content: "",
      onOk: async () => {
        try {
          await apiClient.request("/trafficApps/hideLeads", "POST", {
            codes: rows.map((a) => a.code),
            isHide: isHide,
          });
          Toast.info("成功");
          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  return(
  <>
    <Modal
      onCancel={() => setApp(undefined)}
      onOk={() => setApp(undefined)}
      visible={app}
    >
      <Form>
        <Form.Slot label="App Key">
          <Text style={{ fontFamily: "monospace" }} code>
            {app?.appKey}
          </Text>
        </Form.Slot>
        <Form.Slot label="文档地址">
          <Text link={{ href: apiDocInfo?.url }}>{apiDocInfo?.url}</Text>
        </Form.Slot>
        <Form.Slot label="文档用户名">{apiDocInfo?.username}</Form.Slot>
        <Form.Slot label="文档密码">{apiDocInfo?.password}</Form.Slot>
      </Form>
    </Modal>
    <Crud
      getCrudApi={(crudApi) => {
        setCrudApi(crudApi);
      }}
      canUpdate={true}
      canCreate={true}
      select={true}
      name="渠道App"
      entityKey="trafficApps"
      pageSize={50}
      actions={[
        {
          name: "隐藏客户",
          action: (row: any, rows: any[] | undefined) => {
            hideLeads(row, rows, 1);
          },
        },
        {
          name: "取消隐藏客户",
          action: (row: any, rows: any[] | undefined) => {
            hideLeads(row, rows, 0);
          },
        },
      ]}
      getRowActions={(a) => [
        {
          name: "删除",
          action: () => {
            deleteTrafficApp(a.id);
          },
        },
      ]}
      cols={cols}
    />
  </>
  )
}